"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModifyCompensationPermission = exports.getModifySubsidyPermission = exports.PermissionsDynamic = void 0;
const legacy_config_1 = require("@daytrip/legacy-config");
const legacy_enums_1 = require("@daytrip/legacy-enums");
const legacy_enums_2 = require("@daytrip/legacy-enums");
const legacy_enums_3 = require("@daytrip/legacy-enums");
exports.PermissionsDynamic = {
    // -- for myself (anybody's context) --
    "User_Myself:Read": ({ uid }, userId) => uid === userId,
    "User_Myself:Update": ({ uid }, userId) => uid === userId,
    "UserPassword_Myself:Modify": ({ uid }, userId) => uid === userId,
    // -- for my company driver (company's context) --
    "User_MyCompanyDriver:Read": ({ uid }, driver) => uid === driver.driver.driversCompanyUserId,
    "Chargeback_ForNeverConfirmedOrder:Create": (_data, order) => {
        const departureMS = new Date(order.departureAt).getTime();
        const nowMS = Date.now();
        if (order.confirmedAt === undefined &&
            (order.status === legacy_enums_1.OrderStatus.Cancelled || order.status === legacy_enums_1.OrderStatus.Declined) &&
            departureMS > nowMS) {
            return true;
        }
        return false;
    },
    "Chargeback_Cancelled:Create": (_data, order) => {
        const dayInMS = 1000 * 60 * 60 * 24;
        const departureMS = new Date(order.departureAt).getTime();
        const nowMS = Date.now();
        if (order.status === legacy_enums_1.OrderStatus.Cancelled &&
            departureMS - nowMS > dayInMS &&
            !order.departureDateChangedLessThan24hUntilDeparture) {
            return true;
        }
        return false;
    },
    "Chargeback_Surplus:Create": (_data, order, totalPrice, paidPrice, chargebackAmount) => {
        const dayInMS = 1000 * 60 * 60 * 24;
        const departureMS = new Date(order.departureAt).getTime();
        const nowMS = Date.now();
        if (chargebackAmount) {
            if (departureMS - nowMS > dayInMS && paidPrice > totalPrice && paidPrice - totalPrice >= chargebackAmount) {
                return true;
            }
        }
        else if (departureMS - nowMS > dayInMS && paidPrice > totalPrice) {
            return true;
        }
        return false;
    },
    "Order_Myself:Read": ({ uid }, order) => order.userId === uid,
    "Orders_Myself:Read": ({ uid }, userIds) => userIds.length === 1 && userIds[0] === uid,
    "Order_Myself:Update": ({ uid }, order) => order.userId === uid,
    "ClaimOrderRequest_Myself:Create": ({ roleDetails }, order, orderCountries, orderPrice) => {
        if (!roleDetails || !roleDetails["can-claim-trips"]) {
            return false;
        }
        const permissionDetails = roleDetails["can-claim-trips"];
        const nowMS = Date.now();
        const departureMS = new Date(order.departureAt).getTime();
        const maxMsBeforeTrip = 1000 * 60 * 60 * 24 * permissionDetails.maxDaysBeforeTrip;
        const msBeforeDeparture = departureMS - nowMS;
        if (msBeforeDeparture < 0 || msBeforeDeparture > maxMsBeforeTrip) {
            return false;
        }
        if (!orderPrice || orderPrice > permissionDetails.maxOrderPrice) {
            return false;
        }
        const orderCountryAllowed = orderCountries.some((country) => permissionDetails.countryIdsForClaiming.includes(country));
        if (!orderCountryAllowed) {
            return false;
        }
        return true;
    },
    "Pin_Myself:Read": ({ uid }, assignation, user) => !!(assignation.userId === uid || (user.driver && user.driver.driversCompanyUserId === uid)),
    "Payout_Pending:Fail": (_userInfo, payout) => payout && payout.status === legacy_enums_2.PayoutStatus.Pending,
    "Invoice_Myself:Read": ({ uid }, optionsUserIds) => optionsUserIds.length === 1 && optionsUserIds[0] === uid,
    "Feedback_Myself:Read": ({ uid }, order) => order.passengers.some((p) => p.userId === uid),
    "Feedback_Myself:Create": ({ uid }, order) => order.passengers.some((p) => p.userId === uid),
    "Feedback_Myself:Update": ({ uid }, order) => order.passengers.some((p) => p.userId === uid),
    "Order_Myself:Cancel": ({ uid }, order) => order.userId === uid,
    "Unavailability_Myself:Read": ({ uid }, unavailabilityOwnerUserId) => uid === unavailabilityOwnerUserId,
    "Unavailability_Myself:Update": ({ uid }, unavailabilityOwnerUserId) => uid === unavailabilityOwnerUserId,
    "ClaimingToolSubscription_Myself:Read": ({ uid }, { userId }) => uid === userId,
    "OrderInAssignedCountries:Update": ({ roleDetails }, order) => {
        const rmCountryIds = roleDetails?.[legacy_enums_3.RolesEnum.SeniorRegionalManager]?.countryIds || [];
        return rmCountryIds.includes(order.originLocation.countryId);
    },
    "Assignation_Myself:Modify": ({ uid }, user) => {
        return !!(uid === user._id || (user.driver && user.driver.driversCompanyUserId === uid));
    },
    "AssignationsData_Myself:Read": ({ uid }, { userId }) => uid === userId,
    "BillingInformation_Myself:Modify": ({ uid }, user) => {
        return !!(uid === user._id || (user.driver && user.driver.driversCompanyUserId === uid));
    },
    "MangopayInformation_Myself:Update": ({ uid }, user) => {
        return !!(uid === user._id || (user.driver && user.driver.driversCompanyUserId === uid));
    },
    "DriversCompany_Myself:Read": ({ uid }, { userId }) => uid === userId,
    "DriversCompany_Myself:Modify": ({ uid }, user) => {
        return !!(uid === user._id || (user.driver && user.driver.driversCompanyUserId === uid));
    },
    "My_DriversCompany:Read": ({ uid }, user, companyUserId) => {
        return !!(uid === user._id || (user.driver && user.driver.driversCompanyUserId === companyUserId));
    },
    "User_Driver_Myself:Read": ({ uid }, user) => {
        return !!(uid === user._id || (user.driver && user.driver.driversCompanyUserId === uid));
    },
    "User_Driver_RM:Modify": ({ uid }, user, rm) => {
        return uid === rm.userId && !!(user.driver || user.driversCompany) && rm.countryIds.includes(user.countryId);
    },
    "User_Driver_Myself:Update": ({ uid }, user) => {
        return !!(uid === user._id || (user.driver && user.driver.driversCompanyUserId === uid));
    },
    "DriverDocument_Myself:Modify": ({ uid }, user) => {
        return !!(uid === user._id || (user.driver && user.driver.driversCompanyUserId === uid));
    },
    "DriverBalance_Myself:Read": ({ uid }, user) => {
        return !!(uid === user._id || (user.driver && user.driver.driversCompanyUserId === uid));
    },
    "DriverVehicle_Myself:Update": ({ uid }, user) => {
        return !!(uid === user._id || (user.driver && user.driver.driversCompanyUserId === uid));
    },
    "DriverVehicleDocument_Myself:Modify": ({ uid }, user) => {
        return !!(uid === user._id || (user.driver && user.driver.driversCompanyUserId === uid));
    },
    "Payment_Myself:Create": ({ uid }, { userId }) => uid === userId,
    "Vehicle_Myself:Create": ({ uid }, { userId }) => uid === userId,
    "TravelAgent:Modify": (isTravelAgent) => Boolean(isTravelAgent),
};
const getModifySubsidyPermission = (subsidy) => {
    return subsidy && subsidy > legacy_config_1.HIGH_SUBSIDY_LIMIT ? "SubsidyOverLimit:Modify" : "Assignation:Modify";
};
exports.getModifySubsidyPermission = getModifySubsidyPermission;
const getModifyCompensationPermission = (compensation) => {
    return compensation && compensation > legacy_config_1.HIGH_COMPENSATION_LIMIT
        ? "CompensationOverLimit:Modify"
        : "Assignation:Modify";
};
exports.getModifyCompensationPermission = getModifyCompensationPermission;
//# sourceMappingURL=permissions.js.map